"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _enums = require("./enums");
var _util = _interopRequireDefault(require("../meeting/util"));
var canUserStart = function canUserStart(displayHints, userPolicies) {
  return (displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_START) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_START)) && _util.default.selfSupportsFeature(_constants.SELF_POLICY.SUPPORT_NETWORK_BASED_RECORD, userPolicies);
};
var canUserPause = function canUserPause(displayHints, userPolicies) {
  return (displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_PAUSE) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_PAUSE)) && _util.default.selfSupportsFeature(_constants.SELF_POLICY.SUPPORT_NETWORK_BASED_RECORD, userPolicies);
};
var canUserResume = function canUserResume(displayHints, userPolicies) {
  return (displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_RESUME) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_RESUME)) && _util.default.selfSupportsFeature(_constants.SELF_POLICY.SUPPORT_NETWORK_BASED_RECORD, userPolicies);
};
var canUserStop = function canUserStop(displayHints, userPolicies) {
  return (displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_STOP) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_STOP)) && _util.default.selfSupportsFeature(_constants.SELF_POLICY.SUPPORT_NETWORK_BASED_RECORD, userPolicies);
};
var isPremiseRecordingEnabled = function isPremiseRecordingEnabled(displayHints, userPolicies) {
  return (displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_START) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_PAUSE) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_STOP) || displayHints.includes(_constants.DISPLAY_HINTS.PREMISE_RECORDING_CONTROL_RESUME)) && _util.default.selfSupportsFeature(_constants.SELF_POLICY.SUPPORT_NETWORK_BASED_RECORD, userPolicies);
};
var extractLocusId = function extractLocusId(url) {
  return url === null || url === void 0 ? void 0 : url.split('/').pop();
};
var deriveRecordingStates = function deriveRecordingStates(action) {
  var recording;
  var paused;
  switch (action) {
    case _enums.RecordingAction.Start:
      recording = true;
      paused = false;
      break;
    case _enums.RecordingAction.Stop:
      recording = false;
      paused = false;
      break;
    case _enums.RecordingAction.Resume:
      recording = true;
      paused = false;
      break;
    case _enums.RecordingAction.Pause:
      recording = true;
      paused = true;
      break;
    default:
      throw new Error("Recording state cannot be derived from invalid action: ".concat(action));
  }
  return {
    recording: recording,
    paused: paused
  };
};
var _default = exports.default = {
  canUserStart: canUserStart,
  canUserPause: canUserPause,
  canUserResume: canUserResume,
  canUserStop: canUserStop,
  isPremiseRecordingEnabled: isPremiseRecordingEnabled,
  deriveRecordingStates: deriveRecordingStates,
  extractLocusId: extractLocusId
};
//# sourceMappingURL=util.js.map
